export default "__VITE_PUBLIC_ASSET__21b406da__"